document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('NewsletterForm')) {
        var signupRequest;
        document.getElementById('NewsletterForm').addEventListener('submit', (evt) => {
            evt.preventDefault();
            var subscribeForm = document.getElementById('NewsletterForm');
            var subscribeFormData = new FormData(subscribeForm);
            var email = subscribeFormData.get('email');
            var listid = subscribeFormData.get('listid');
            signupRequest = new XMLHttpRequest();
            signupRequest.open('POST', '/api/newsletter/SignupNewsletter');
            signupRequest.setRequestHeader('Content-Type', 'application/json');
            signupRequest.responseType = 'json';
            signupRequest.onreadystatechange = () => {
                if (signupRequest.readyState === XMLHttpRequest.DONE) {
                    if (signupRequest.status === 200 && signupRequest.response.success) {
                        document.getElementById('SuccessMessage').style.display = 'block';
                        subscribeForm.reset();
                        setTimeout(() => {
                            document.getElementById('SuccessMessage').style.display = 'none';
                        }, 5000);
                    } else {
                        document.getElementById('FailMessage').style.display = 'block';
                        setTimeout(() => {
                            document.getElementById('FailMessage').style.display = 'none';
                        }, 5000);
                    }
                    console.log(signupRequest.response.message);
                }
            };
            var signupRequestData = {};
            signupRequestData.email = email;
            signupRequestData.listid = listid;
            signupRequest.send(JSON.stringify(signupRequestData));
        });
    }

    var clickEvent = (evt) => {
        evt.preventDefault();
        evt.target.parentNode.classList.toggle('open');
    };

    if (document.querySelector('.product-info__title') != null) {
        document.querySelectorAll('.product-info__title').forEach(function (e) {
            e.addEventListener('click', clickEvent);
        });
    }

    var clickEvent2 = (evt) => {
        if(evt.target.classList.contains('plus') || evt.target.classList.contains('product-detail__quantity-increase')){

            var input = evt.currentTarget.children[1];
            var value = parseInt(input.value);
            
            input.setAttribute('value', value + 1);

        } else if(evt.target.classList.contains('minus') || evt.target.classList.contains('product-detail__quantity-decrease')){
            var input = evt.currentTarget.children[1];
            var value = parseInt(input.value);

            if (value > 0) {
                input.setAttribute('value', value - 1);
            }
        }
    };

    if(document.querySelector('.qty_container') != null) {
        document.querySelectorAll('.qty_container').forEach(function(e){
            e.addEventListener('click', clickEvent2);
        });
    }
    
    if(document.querySelector('.product-detail__quantity-wrapper') != null) {
        document.querySelectorAll('.product-detail__quantity-wrapper').forEach(function(e){
            e.addEventListener('click', clickEvent2);
        });
    }

    var clickEvent3 = (evt) => {
        var children = evt.currentTarget.parentNode.children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if(child.classList.contains('hidden')){
                while(child.childNodes.length > 0){
                    evt.currentTarget.parentNode.appendChild(child.childNodes[0]);
                }
                child.remove();
            }
        }
        
        evt.currentTarget.remove();
    }

    setTimeout(() => {
        if(document.querySelector('.showmore') != null){
            document.querySelectorAll('.showmore').forEach(function(e){
                e.addEventListener('click', clickEvent3);
            });
        }
    }, 1000);

    var opened = false;

    var clickVariant = (event) => {
        var target = event.currentTarget.parentNode;
        if (!opened) {
            target.lastElementChild.style.display = 'block';
            setTimeout(() => {
                    opened = true;
                },
                10);
        } else {
            target.lastElementChild.style.display = 'none';
            opened = false;
        }
    }


    if(document.getElementById('variants') != null){
        document.getElementsByTagName('html')[0].addEventListener('click', function(evt){

            if(!evt.target.classList.contains('variants') && opened){
                document.querySelectorAll('.variants-holder .variants').forEach(function(e){
                    e.style.display = 'none';
                    opened = false;
                });
            }
        });

        document.querySelectorAll('#variants .has-variants').forEach(function(e){
            e.addEventListener('click', clickVariant);
        });
    }
});